<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>
<p-dialog
  [header]="'sessionTimeout' | translate"
  [visible]="showTimeoutWarning()"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
>
  <p>{{ 'sessionTimeoutMessage' | translate: { time: timeRemaining() } }}</p>
  <ng-template #footer>
    <p-button
      class="dap-stay-logged-in"
      [label]="'stayLoggedIn' | translate"
      [text]="true"
      (onClick)="stayLoggedIn()"
    />
    <p-button
      class="dap-log-out"
      [label]="'logOut' | translate"
      (onClick)="logOut()"
    />
  </ng-template>
</p-dialog>
